import { PointPrimitiveCollection, Cartesian3, Color } from "cesium"

export default class PointLayer {
  constructor() {
    this.points = {}
  }

  add(point) {
    const { id, lng, lat, pixelSize, color, outlineColor, outlineWidth, attr } = point
    const entity = {
      id,
      position: Cartesian3.fromDegrees(lng, lat, 0.1),
      pixelSize,
      color: Color.fromCssColorString(color),
      outlineColor: Color.fromCssColorString(outlineColor),
      outlineWidth: outlineWidth ? outlineWidth : 0
    }
    let pointPrimitive = this.pointList.add(entity)
    pointPrimitive.attr = attr
  }

  /**
   * 
   * @param {Viewer} viewer 
   */
  addTo(primitives, id) {
    this.pointList = primitives.add(new PointPrimitiveCollection())
    this.pointList.metadata = {id: id}
    primitives.raiseToTop(this.pointList)
    this.primitives = primitives
  }

  clear() {
    this.pointList.removeAll()
  }

  destory() {
    this.clear()
    this.primitives.remove(this.pointList)
  }
}